import shallow from 'zustand/shallow';
import { useStore } from '../../../store/store';

const selector = ({ configuration, updateBox }) => ({ configuration, updateBox });

/**
 * Édition du sac de props d'une box partagée (Volet, Carte info), depuis le
 * panel de droite.
 *
 * Le style du template n'est qu'un **modèle** : au drop, comme à chaque fois
 * qu'on en applique un, ses valeurs sont recopiées dans la box. Ce hook écrit
 * dans cette copie, `box.content[contentKey]`.
 *
 * Il expose les mêmes conversions de couleur que l'onglet du configurateur :
 * l'interface raisonne en labels de palette, la box stocke des chaînes CSS —
 * c'est ce qui permet au parser de recopier le sac tel quel dans le bloc web.
 */
export function useBoxPropsEditor(box, contentKey) {
  // `shallow` : le sélecteur forge un objet à chaque appel, la box se
  // redessinait à chaque changement du store, même sur une autre box.
  const { configuration, updateBox } = useStore(selector, shallow);
  const props = box.content?.[contentKey] || {};

  const setProps = (patch) => {
    updateBox(box.id, (draftBox) => {
      draftBox.content[contentKey] = { ...draftBox.content[contentKey], ...patch };
    });
  };

  return {
    props,
    setProp: (key, value) => setProps({ [key]: value }),
    setProps,
    labelOfColor: (cssColor) => configuration.colors
      .find((c) => c.style === cssColor)?.label ?? 'transparent',
    colorOfLabel: (label) => (label === 'transparent'
      ? ''
      : configuration.colors.find((c) => c.label === label)?.style ?? ''),
  };
}
